import { HygraphRichTextProps } from '@/components/hygraph-rich-text';

export type RichTextTransformerProps = {
  heading?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any;
};

export default function richTextTransformer(
  props: RichTextTransformerProps
): HygraphRichTextProps | undefined {
  if (!props) return undefined;

  const heading = props?.heading && {
    type: 'heading-two',
    children: [
      {
        text: props.heading,
      },
    ],
  };

  const content = {
    ...props.content,
    children: [
      ...(heading ? [heading] : []),
      ...(props.content?.children || []),
    ],
  };

  return {
    content,
  };
}
